// Research data and citations for Holosonic website

export const researchCitations = {
  volumetricPrinting: {
    id: 1,
    authors: "Kuang, X. et al.",
    title: "The road ahead in materials and technologies for volumetric 3D printing",
    journal: "Nature Reviews Materials",
    year: 2025,
    url: "https://am2.engr.wisc.edu/2025/03/08/nat-rev-mater-the-road-ahead-in-materials-and-technologies-for-volumetric-3d-printing/",
    institution: "University of Wisconsin–Madison",
    keyPoints: [
      "Volumetric 3D printing enables layerless fabrication",
      "Faster than conventional layer-by-layer methods",
      "Overcomes surface quality issues",
      "Contactless process critical for living cells"
    ]
  },
  acousticHolograms: {
    id: 2,
    authors: "Melde, K. et al.",
    title: "Touchless 3D printing using acoustic holograms",
    journal: "Advanced Science",
    year: 2023,
    url: "https://3dprintingindustry.com/news/max-planck-and-heidelberg-researchers-explore-touchless-3d-printing-using-acoustic-holograms-221312/",
    institution: "Max Planck Institute for Medical Research, Heidelberg University",
    keyPoints: [
      "Multiple acoustic holograms create precise 3D pressure fields",
      "Enables manipulation of solid particles, gel beads, and living cells",
      "Non-contact, gentle, non-toxic to cells",
      "Maintains sterility for biological applications"
    ]
  },
  deepAcousticPrinting: {
    id: 3,
    authors: "Kuang, X.",
    title: "Deep-penetration acoustic volumetric printing",
    institution: "University of Wisconsin–Madison",
    url: "https://photoacoustics.pratt.duke.edu/research/deep-acoustic-printing",
    keyPoints: [
      "Enables 3D printing inside materials that scatter light",
      "Can print beneath centimeters-thick human tissue",
      "Sound-active material design for ultrasound 3D printing"
    ]
  }
};

export const technicalSpecs = {
  frequencyRange: "20 kHz to 2+ MHz (ultrasonic to megahertz)",
  particleSizeRange: "10 nm to 5 mm",
  positioningPrecision: "Sub-10 μm (sub-micron) ",
  penetrationDepth: "Up to centimeters through biological tissue",
  printingSpeed: "Faster than layer-by-layer methods",
  cellViability: "Maintained through gentle acoustic fields"
};

export const applications = {
  volumetricPrinting: [
    "Optical and photonic components",
    "Rapid prototyping",
    "Soft robotics",
    "Bioprinting of living cells"
  ],
  acousticHolograms: [
    "Biomedicine",
    "Drug delivery",
    "Tissue engineering",
    "Precise and complex structure fabrication"
  ],
  deepPenetration: [
    "In vivo printing",
    "Printing through optically opaque materials",
    "Medical device fabrication"
  ]
};

